import Vue from 'vue';
import Main from './views/Main.vue';
import homePageRouter from './homePageRouter';
import PlaceOrderComponent from './components/place-order/place-order.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
// 首页
// export const index = {
//     path: '/index',
//     name: 'index',
//     meta: {
//         title: '鸭嘴兽官网 - 集装箱运输-拖车报关-货车定位'
//     },
//     component: resolve => {
//         require(['./views/index.vue'], resolve);
//     }
// };
// 新首页
// export const index = {
//     path: '/index',
//     name: 'index',
//     meta: {
//         title: '鸭嘴兽首页'
//     },
//     component: resolve => {
//         require(['./views/home-page/default/default.vue'], resolve);
//     }
// };
// 注册
export const register = {
    path: '/register',
    name: 'register',
    meta: {
        // title: '车辆跟踪'
    },
    component: resolve => {
        require(['./views/register/register.vue'], resolve);
    }
};
export const mapTest = {
    path: '/map-test',
    name: 'map-test',
    meta: {
        // title: '车辆跟踪'
    },
    component: resolve => {
        require(['./views/map-test/map-test.vue'], resolve);
    }
};
export const registerSupplement = {
    path: '/register-supplement',
    name: 'register-supplement',
    meta: {
    },
    component: resolve => {
        require(['./views/register-supplement/register-supplement.vue'], resolve);
    }
};
export const registerPersonal = {
    path: '/register-personal',
    name: 'register-personal',
    meta: {
    },
    component: resolve => {
        require(['./views/register-personal/register-personal.vue'], resolve);
    }
};
export const registerCompany = {
    path: '/register-company',
    name: 'register-company',
    meta: {
    },
    component: resolve => {
        require(['./views/register-company/register-company.vue'], resolve);
    }
};
export const personalCenter = {
    path: '/personal-center',
    name: 'personal-center',
    meta: {

    },
    component: resolve => {
        require(['./views/personal-center/personal-center.vue'], resolve);
    }
};
export const login = {
    path: '/login',
    name: 'login',
    meta: {
        // title: '车辆跟踪'
    },
    component: resolve => {
        require(['./views/login/login.vue'], resolve);
    }
};
export const reset = {
    path: '/reset',
    name: 'reset',
    meta: {

    },
    component: resolve => {
        require(['./views/reset/reset.vue'], resolve);
    }
};
// 个毛体件数填写
export const dataComplet = {
    path: '/data-complet',
    name: 'data-complet',
    meta: {

    },
    component: resolve => {
        require(['./views/data-complet/data-complet.vue'], resolve);
    }
};
// 中转港数据
export const dataToPart = {
    path: '/data-topart',
    name: 'data-topart',
    meta: {

    },
    component: resolve => {
        require(['./views/data-topart/data-topart.vue'], resolve);
    }
};
export const truckLocation = {
    path: '/truck-location',
    name: 'truck-location',
    meta: {
        // title: '车辆跟踪'
    },
    component: resolve => {
        require(['./views/truck-location/truck-location.vue'], resolve);
    }
};
// 任务大厅
export const missionHall = {
    path: '/mission-hall',
    name: 'mission-hall',
    meta: {
        // title: '任务大厅'
    },
    component: resolve => {
        require(['./views/mission-hall/mission-hall.vue'], resolve);
    }
};
// 关于我们
export const aboutUs = {
    path: '/about-us',
    name: 'about-us',
    meta: {
        // title: '关于我们'
    },
    component: resolve => {
        require(['./views/about-us/about-us.vue'], resolve);
    }
};
// 合作流程
// export const cooperationProcess = {
//     path: '/cooperation-process',
//     name: 'cooperation-process',
//     meta: {
//         // title: '合作流程'
//     },
//     component: resolve => {
//         require(['./views/cooperation-process/cooperation-process.vue'], resolve);
//     }
// };
// 运价查询
export const queryCharge = {
    path: '/query-charge',
    name: 'query-charge',
    meta: {
        // title: '运价查询'
    },
    component: resolve => {
        require(['./views/query-charge/query-charge.vue'], resolve);
    }
};
// 新运价查询
export const queryChargeNew = {
    path: '/query-charge-new',
    name: 'query-charge-new',
    meta: {
        // title: '运价查询'
    },
    component: resolve => {
        // require(['./views/query-charge-new/query-charge-new.vue'], resolve);
        require(['./views/main-query-charge-more/main-query-charge-more.vue'], resolve);
    }
};
// 异常费用页面
export const transportPriceMap = {
    path: '/exception-fee',
    name: 'exception-fee',
    meta: {
        // title: '异常费用'
    },
    component: resolve => {
        require(['./views/exception-fee/exception-fee.vue'], resolve);
    }
};

export const page404 = {
    path: '/*',
    name: 'error_404',
    meta: {
        title: '404-页面不存在'
    },
    component: resolve => {
        require(['./views/error_page/404.vue'], resolve);
    }
};

export const page401 = {
    path: '/401',
    meta: {
        title: '401-权限不足'
    },
    name: 'error_401',
    component: resolve => {
        require(['./views/error_page/401.vue'], resolve);
    }
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error_500',
    component: resolve => {
        require(['./views/error_page/500.vue'], resolve);
    }
};

export const preview = {
    path: '/preview',
    name: 'preview',
    component: resolve => {
        require(['./views/form/article-publish/preview.vue'], resolve);
    }
};

export const locking = {
    path: '/locking',
    name: 'locking',
    component: resolve => {
        require(['./views/main_components/locking-page.vue'], resolve);
    }
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    component: Main,
    children: [
        {
            path: 'home',
            title: '订单中心',
            name: 'home_index',
            component: resolve => {
                require(['./views/home/home.vue'], resolve);
            }
        },
        {
            path: '/cross-border-logistics-detail/:id',
            title: '好柜详情',
            name: 'cross-border-logistics-detail',
            component: resolve => {
                require(['./views/cross-border-logistics-detail/cross-border-logistics-detail.vue'], resolve);
            }
        },
        {
            path: '/account-details',
            title: '账单详情',
            name: 'account-details',
            component: resolve => {
                require(['./views/account-details/account-details.vue'], resolve);
            }
        },
        {
            path: '/create-order',
            title: '创建订单',
            name: 'create-order',
            component: resolve => {
                require(['./views/create-order/create-order.vue'], resolve);
            }
        },
        {
            path: '/create-detail-order',
            title: '新建订单',
            name: 'create-detail-order',
            component: resolve => {
                require(['./views/create-detail-order/create-detail-order.vue'], resolve);
            }
        },
        {
            path: '/edit-shipping-bill',
            title: '舱单提交',
            name: 'edit-shipping-bill',
            component: resolve => {
                require(['./views/shipping-bill/form.vue'], resolve);
            }
        },
        {
            path: '/place-order/pre',
            title: ' 下单 ',
            name: 'place-order-pre',
            component: Vue.extend({
                ...PlaceOrderComponent,
                name: 'place-order-pre'
            })
        },
        {
            path: '/view-shipping-bill',
            title: '舱单查看',
            name: 'view-shipping-bill',
            component: resolve => {
                require(['./views/shipping-bill/view.vue'], resolve);
            }
        },
        {
            path: '/shipping-bill/service-scope',
            title: '舱单服务范围',
            name: 'shipping-bill_servicescope',
            component: resolve => {
                require([
                    './views/shipping-bill/service-scope.vue'
                ], resolve);
            }
        },
        {
            path: '/shipping-bill/edit-guide',
            title: '舱单修改指南',
            name: 'shipping-bill_editguide',
            component: resolve => {
                require([
                    './views/shipping-bill/edit-guide.vue'
                ], resolve);
            }
        },
        {
            path: '/LCL/create-order',
            name: 'LCL-create-order',
            title: '拼箱下单',
            component: resolve => {
                require(['./views/LCL-create-order/LCL-create-order.vue'], resolve);
            }
        },
        {
            path: '/main-order-number/:orderNumber',
            title: '提单详情',
            name: 'main-order-number',
            // access: 'ORDER_BOOKING',
            component: resolve => {
                require([
                    './views/main-order-number/main-order-number.vue'
                ], resolve);
            }

        },
        {
            path: '/capacity-limit-query',
            title: '运力额度查询',
            name: 'capacity-limit-query',
            component: resolve => {
                require(['./views/capacity-limit-query/capacity-limit-query.vue'], resolve);
            }
        },
        {
            path: '/create-history-order',
            icon: 'ios-home-outline',
            name: 'create-history-order',
            title: '老门点下单', // 运价查询
            component: resolve => {
                require([
                    './views/create-history-order/create-history-order.vue'
                ], resolve);
            }
        },
        {
            path: '/confirm-box/index',
            icon: 'iconziyuan',
            name: 'confirm-box',
            title: '待确认做箱',
            component: resolve => {
                require([
                    './views/confirm-box/confirm-box.vue'
                ], resolve);
            }
        },
        {
            path: '/peak-season-quota-page/index',
            icon: 'iconziyuan',
            name: 'peak-season-quota-page',
            title: '旺季额度',
            component: resolve => {
                require([
                    './views/peak-season-quota-page/peak-season-quota-page.vue'
                ], resolve);
            }
        }
    ]
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
    {
        path: '/main-query-charge',
        icon: 'iconchaxun',
        name: 'main-query-charge',
        title: '查运价', // 运价查询
        component: Main,
        children: [
            {
                path: 'index',
                title: '查运价', // 运价查询
                name: 'main-query-charge_index',
                access: 'MAIN_QUERY_CHARGE',
                component: resolve => {
                    require([
                        './views/main-query-charge-more/main-query-charge-more.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/cross-border-logistics',
        icon: 'icon004-jizhuangxiang',
        name: 'cross-border-logistics',
        title: '跟好柜', // 跟好柜
        component: Main,
        children: [
            {
                path: 'index',
                title: '跟好柜', // 跟好柜
                name: 'cross-border-logistics_index',
                access: 'CROSS-BORDER-LOGISTICS',
                component: resolve => {
                    require([
                        './views/cross-border-logistics/cross-border-logistics.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/place-order',
        icon: 'iconxiadan1',
        name: 'place-order',
        title: '下单',
        component: Main,
        children: [
            {
                path: 'index',
                title: '下单',
                name: 'place-order-index',
                access: 'PLACE_ORDER',
                component: Vue.extend({
                    ...PlaceOrderComponent,
                    name: 'place-order-index'
                })
            }
        ]

    },
    {
        path: '/coupon',
        icon: 'iconyouhuiquan1',
        name: 'coupon',
        title: '我的优惠券', // 运价查询
        component: Main,
        children: [
            {
                path: 'index',
                title: '我的优惠券', // 运价查询
                name: 'coupon_index',
                access: 'COUPON',
                component: resolve => {
                    require([
                        './views/coupon/coupon.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/order-booking',
        icon: 'iconziyuan',
        name: 'order-booking',
        title: '我的订单',
        component: Main,
        children: [
            {
                path: 'index',
                title: '我的订单',
                name: 'order-booking_index',
                access: 'ORDER_BOOKING',
                component: resolve => {
                    require([
                        './views/order-booking/order-booking.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/draft-box',
        icon: 'iconziyuan',
        name: 'draft-box',
        title: '草稿箱',
        component: Main,
        children: [
            {
                path: 'index',
                title: '草稿箱',
                name: 'draft-box_index',
                access: 'ORDER_BOOKING',
                component: resolve => {
                    require([
                        './views/draft-box/order-booking.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/shipping-bill',
        icon: 'iconfasong',
        name: 'shipping-bill',
        title: '舱单发送',
        component: Main,
        children: [
            {
                path: 'index',
                title: '舱单发送',
                name: 'shipping-bill_index',
                access: 'SHIPPING_BILL',
                component: resolve => {
                    require([
                        './views/shipping-bill/shipping-bill.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/declare-order',
        icon: 'iconziyuan',
        name: 'declare-order',
        title: '报关订单',
        component: Main,
        children: [
            {
                path: 'index',
                title: '报关订单',
                name: 'declare-order_index',
                access: 'DECLARE_ORDER',
                component: resolve => {
                    require([
                        './views/declare-order/declare-order.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/order-tracking',
        icon: 'icongenzong',
        name: 'order-tracking',
        title: '运输跟踪',
        component: Main,
        children: [
            {
                path: 'index',
                title: '运输跟踪',
                name: 'order-tracking_index',
                access: 'ORDER_TRACKING',
                component: resolve => {
                    require([
                        './views/order-tracking/order-tracking.vue'
                    ], resolve);
                }
            }
        ]
    },
    // {
    //     path: '/LCL-order',
    //     icon: 'icongengduopintuan',
    //     name: 'LCL-order',
    //     title: '拼箱订单',
    //     component: Main,
    //     children: [
    //         {
    //             path: 'index',
    //             title: '拼箱订单',
    //             name: 'LCL-order_index',
    //             access: 'LCL_ORDER',
    //             component: resolve => {
    //                 require(['./views/LCL-order/LCL-order.vue'], resolve);
    //             }
    //         }
    //     ]
    // },
    {
        path: '/container-orders',
        icon: 'icondingdandingdanchaxun',
        name: 'container-orders',
        title: '箱单查询',
        component: Main,
        children: [
            {
                path: 'index',
                title: '箱单查询',
                name: 'container-orders_index',
                access: 'CONTAINER_ORDER',
                component: resolve => {
                    require(['./views/container-orders/container-orders.vue'], resolve);
                }
            }
        ]
    },
    {
        path: '/data-compare',
        icon: 'iconicon_function_tongji',
        name: 'data-compare',
        title: '进港数据对比',
        component: Main,
        children: [
            {
                path: 'index',
                title: '进港数据对比',
                name: 'data-compare_index',
                access: 'DATA_COMPARE',
                component: resolve => {
                    require(['./views/data-compare/data-compare.vue'], resolve);
                }
            }
        ]
    },
    {
        path: '/fee-confirmation',
        icon: 'iconfeiyong_zhangdan',
        name: 'fee-confirmation',
        title: '费用确认',
        component: Main,
        children: [
            {
                path: 'index',
                title: '费用确认',
                name: 'fee-confirmation_index',
                access: 'FEE_CONFIRMATION',
                component: resolve => {
                    require([
                        './views/fee-confirmation/fee-confirmation.vue'
                    ], resolve);
                }
            }
        ]

    },
    {
        path: '/daily-bill-query',
        icon: 'iconfeiyongjiesuandan',
        name: 'daily-bill-query',
        title: '所有费用',
        component: Main,
        children: [
            {
                path: 'index',
                title: '所有费用',
                name: 'daily-bill-query_index',
                access: 'DAILY_BILL_QUERY',
                component: resolve => {
                    require([
                        './views/fee-confirmation/daily-bill-query.vue'
                    ], resolve);
                }
            }
        ]

    },
    {
        path: '/account-checking',
        icon: 'icondingdanjilu',
        name: 'account-checking',
        title: '月结对账',
        component: Main,
        children: [
            {
                path: 'index',
                title: '月结对账',
                name: 'account-checking_index',
                access: 'ACCOUNT_CHECKING',
                component: resolve => {
                    require([
                        './views/account-checking/account-checking.vue'
                    ], resolve);
                }
            }
        ]
    },
    {
        path: '/child-customer',
        icon: 'iconbiaoqing',
        name: 'child-customer',
        title: '我的客户',
        component: Main,
        children: [
            {
                path: 'index',
                title: '我的客户',
                name: 'child-customer_index',
                access: 'CHILD_CUSTOMER',
                component: resolve => {
                    require([
                        './views/child-customer/child-customer.vue'
                    ], resolve);
                }
            }
        ]
    }
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    register,
    mapTest,
    registerSupplement,
    dataComplet,
    dataToPart,
    registerPersonal,
    registerCompany,
    personalCenter,
    login,
    reset,
    truckLocation,
    missionHall,
    aboutUs,
    queryCharge,
    queryChargeNew,
    transportPriceMap,
    otherRouter,
    preview,
    locking,
    ...appRouter,
    ...homePageRouter,
    page500,
    page401,
    page404
];



// WEBPACK FOOTER //
// ./src/router.js